import React, { useLayoutEffect } from "react";
import { Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import { UserContextProvider } from "../pages/pre-built/user-manage/UserContext";
import Homepage from "../pages/Homepage";
import Invest from "../pages/Invest";
import Blank from "../pages/others/Blank";
import UserListRegular from "../pages/pre-built/user-manage/UserListRegular";
import UserContactCard from "../pages/pre-built/user-manage/UserContactCard";
import UserDetails from "../pages/pre-built/user-manage/UserDetailsRegular";
import UserListCompact from "../pages/pre-built/user-manage/UserListCompact";
import UserProfileRegular from "../pages/pre-built/user-manage/UserProfileRegular";
import UserProfileSetting from "../pages/pre-built/user-manage/UserProfileSetting";
import UserProfileNotification from "../pages/pre-built/user-manage/UserProfileNotification";
import UserProfileActivity from "../pages/pre-built/user-manage/UserProfileActivity";
import ProductList from "../pages/pre-built/products/ProductList";
import InvoiceList from "../pages/pre-built/invoice/InvoiceList";
import InvoiceDetails from "../pages/pre-built/invoice/InvoiceDetails";
import InvoicePrint from "../pages/pre-built/invoice/InvoicePrint";
import Error404Modern from "../pages/error/404-modern";
import Login from "../pages/auth/Login";
import ChangePassword from "../pages/auth/ChangePassword";
import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";
import OrderList from "../pages/orders/OrderList";
import AbandonedCheckouts from "../pages/orders/AbandonedCheckouts";
import CategoryList from "../pages/category/CategoryList";
import AddProduct from "../pages/pre-built/products/AddProduct";
import OfferBar from "../pages/offerBar/OfferBar";
import ViewBanner from "../pages/banner/ViewBanner";
import UpdateSocialLinkPage from "../pages/pre-built/social-link/Social-Link";
import UpdateContactPage from "../pages/pre-built/contact-detail/Contact-detail";
import EditProduct from "../pages/pre-built/products/EditProduct";
import ProductMedia from "../pages/pre-built/products/ProductMedia";
import ReviewList from "../pages/reviews/ReviewList";
import EnquiryList from "../pages/enquiries/EnquiryList";
import CustomerList from "../pages/customers/CustomerList";
import PageList from "../pages/content/PageList";
import PageEditor from "../pages/content/PageEditor";
import JournalList from "../pages/content/JournalList";
import JournalEditor from "../pages/content/JournalEditor";
import HomepageContent from "../pages/homepage-content/HomepageContent";
import { useState, useEffect } from "react";
import { handleGetApis } from "../service/Api";

// Route guard component
const ProtectedRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const verifyAdmin = async () => {
      try {
        const res = await handleGetApis(`admin/me`);
        
        if (res && res.status === 200) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (err) {
        console.error("Auth check failed:", err);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };
    verifyAdmin();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

const Router = () => {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      {/* Login Page */}
      <Route index element={<Login />}></Route>

      {/* Protected Pages */}
      <Route element={<ProtectedRoute />}>
        <Route path={`${process.env.PUBLIC_URL}`} element={<Layout />}>
          <Route path="/dashboard" element={<Homepage />}></Route>
          <Route path="/orders" element={<OrderList />}></Route>
          <Route path="/abandoned-checkouts" element={<AbandonedCheckouts />}></Route>
          <Route path="/customers" element={<CustomerList />}></Route>
          <Route path="/pages" element={<PageList />}></Route>
          <Route path="/pages/:key" element={<PageEditor />}></Route>
          <Route path="/journal" element={<JournalList />}></Route>
          <Route path="/journal/:id" element={<JournalEditor />}></Route>
          <Route path="/products" element={<ProductList />}></Route>
          <Route path="/add-product" element={<AddProduct />}></Route>
          <Route path="/edit-product" element={<EditProduct />}></Route>
          <Route path="/product-media" element={<ProductMedia />}></Route>
          <Route path="/categories" element={<CategoryList />}></Route>
          <Route path="/offer-bar" element={<OfferBar />}></Route>
          <Route path="/banner" element={<ViewBanner />}></Route>
          <Route path="/homepage-content" element={<HomepageContent />}></Route>
          <Route path="/social-link" element={<UpdateSocialLinkPage />}></Route>
          <Route path="/contact-detail" element={<UpdateContactPage />}></Route>
          <Route path="/reviews" element={<ReviewList />}></Route>
          <Route path="/enquiries" element={<EnquiryList />}></Route>
          <Route path="/change-password" element={<ChangePassword />}></Route>
          <Route path="invest" element={<Invest />}></Route>
          <Route path="_blank" element={<Blank />}></Route>

          <Route element={<UserContextProvider />}>
            <Route path="user-list-regular" element={<UserListRegular />}></Route>
            <Route path="user-list-compact" element={<UserListCompact />}></Route>
            <Route path="user-contact-card" element={<UserContactCard />}></Route>
            <Route path="user-details-regular/:userId" element={<UserDetails />}></Route>
          </Route>

          <Route>
            <Route path="user-profile-notification" element={<UserProfileNotification />}></Route>
            <Route path="user-profile-regular" element={<UserProfileRegular />}></Route>
            <Route path="user-profile-activity" element={<UserProfileActivity />}></Route>
            <Route path="user-profile-setting" element={<UserProfileSetting />}></Route>
          </Route>

         
            <Route path="product-list" element={<ProductList />}></Route>
        

          <Route path="invoice-list" element={<InvoiceList />}></Route>
          <Route path="invoice-details/:invoiceId" element={<InvoiceDetails />}></Route>
        </Route>
        
        <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
          <Route path="invoice-print/:invoiceId" element={<InvoicePrint />}></Route>
        </Route>
      </Route>

      {/* Fallback Public Pages */}
      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route path="*" element={<Error404Modern />}></Route>
      </Route>
    </Routes>
  );
};
export default Router;
